import ZwxKv from './Index.vue'

ZwxKv.install = function(Vue) {
  Vue.component(ZwxKv.name, ZwxKv)
}

export default ZwxKv
